var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomerSupport = function SvgCustomerSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 60,
    r: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50 9H30a7 7 0 0 0-7 7v48a7 7 0 0 0 7 7h20a7 7 0 0 0 7-7V16a7 7 0 0 0-7-7m5 55a5 5 0 0 1-5 5H30a5 5 0 0 1-5-5V16a5 5 0 0 1 5-5h20a5 5 0 0 1 5 5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M48 35.86H32a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h1v3a1 1 0 0 0 1 1 1 1 0 0 0 .71-.29l3.7-3.71H48a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3m1 12a1 1 0 0 1-1 1H38a1 1 0 0 0-.71.29L35 51.45v-1.59a1 1 0 0 0-1-1h-2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1ZM48 15H32a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h9.59l3.7 3.71A1 1 0 0 0 46 34a1 1 0 0 0 1-1v-3h1a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3m1 12a1 1 0 0 1-1 1h-2a1 1 0 0 0-1 1v1.58l-2.29-2.28A1 1 0 0 0 42 28H32a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Z"
  })));
};
export default SvgCustomerSupport;